<script>
export default {
    name: "PrintPrescription",

    data() {

        return {
            patient: {},
            prescriptions: [],
            medicalReportFile:{}
            
        };
    },

    mounted() {

        Promise.all([ this.fetchPatient(), this.fetchMedicalReportVisit(), ]).then(() => {
            window.print();
            window.onafterprint = () => window.close();
            window.oncancel = () => window.close();
        }).catch(() => {});
    },

    methods: {

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.params.patientID}`;

            return this.$http.get(url).then(({ data }) => {
                this.patient = data.length ? data[0] : {};
            }).catch(() => {});
        },

        fetchPrescriptions() {
            let url = `MedicalFile/GetPatientPrescriptionOrdersforGivenDate`;
                url += `?PatientId=${this.$route.params.patientID}`;
                url += `&VisitNo=${this.$route.params.visitNo}`;
                url += `&OrderDate=${this.$moment().format(`YYYY-MM-DD`)}`;

            return this.$http.get(url).then(({ data }) => {
                this.prescriptions = data;
            }).catch(() => {});
        },
        fetchMedicalReportVisit() {
      const visitNo = this.$route.query.visitNo || this.$route.params.visitNo;

      if (!visitNo) return Promise.reject();

      let url =`MedicalFile/GetPatientVisitMedicalReport`;
      url += `?PatientID=${this.$route.params.patientID}`;
      url += `&VisitNo=${visitNo}`;
      

      return this.$http
        .get(url)
        .then((response) => {
           this.medicalReportFile = response.data[0]||{};
          return Promise.resolve();
        })
        .catch(() => { return Promise.reject(); });
    },

    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <tail-address-header></tail-address-header>
          
        <div class="w-full flex flex-wrap max-h-8 overflow-auto border-b-2 border-t-2 border-gray-800" >
                              <div class="md:w-1/3 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">Name: 
                                        <span class="font-bold">{{ patient.names }}</span></h5>
                              </div>
                              
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">IPFile NO: 
                                        <span class="font-bold">{{ patient.ipfileno }}</span></h5>
                              </div>
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">OPFile NO: 
                                        <span class="font-bold">{{ patient.opfileno }}</span></h5>
                              </div>
                              <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">MRN: 
                                         <span class="font-bold">{{ patient.patienT_ID }}</span></h5>
                              </div>
                             <div class="md:w-1/5 sm:w-full p-tiny">
                                  <h5 
                                    class="font-bold text-sm">Age: 
                                         <span class="font-bold">{{ patient.age }} Yr(s)</span></h5>
                              </div> 
                          </div>
       <h5 class="w-full font-bold text-center">PATIENT MEDICAL REPORT</h5> 
       <tail-stamp></tail-stamp>
       <div class="w-full flex flex-wrap content-start">
            <!-- v-for="dS in medicalReportFile.patientVisitDetail.filter(dS => dS.visitNo == $route.params.visitNo)" :key="dS.id"> -->
               
                <div class="w-1/2 flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Past Medical History</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                        <span v-html="medicalReportFile.historyofIllness || `-`"></span>  
                    </div> 
                    <!-- <div class="w-full text-sm p-1">
                        <span v-html="dS.diagnosisOnAdmission || `-`"></span>
                    </div> -->
                </div>
                <div class="w-1/2 flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Medical Issues Arising/Diagnosis</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                     
                        <span v-html="medicalReportFile.diagnosisOnOP || `-`"></span>  
                        <!-- <span v-html="dS.diagnosis || `-`"></span> -->
                    </div>
                </div>
                <div class="w-full flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Major Complaints</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                        <span v-html="medicalReportFile.chiefComplain || `-`"></span>
                       
                    </div>
                </div>
                <div class="w-full flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">On Examination</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                        <span v-html=" medicalReportFile.physicalExam || `-`"></span>
                    </div>
                </div>
                <div class="w-full flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Vitals</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                        <span v-html="medicalReportFile.patientVitals || `-`"></span>
                        
                    </div>
                </div>
                 <div class="w-full flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Investigations Done</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                       
                         <span v-html="medicalReportFile.investigations || `-`"></span>
                       
                    </div>
                </div>
                <div class="w-full flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Procedures done</h5>
                    </div>
                    <div class="w-full text-sm p-1"> 
                        <span class="my-1" v-html="medicalReportFile.procedures || `-`"></span>
                    </div>
                </div>
                <div class="w-full flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Drugs Received</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                        
                        <span v-html="medicalReportFile.drugs || `-`"></span>
                    </div>
                </div>
                <!-- <div class="w-1/2 flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Progress</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                        <span v-html="dS.progress || `-`"></span>
                    </div>
                </div> -->
             
                <div class="w-full flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Treatment/Plan of Management</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                        <!-- {{ medicalReportFile.managementNotes[0].managementNotes }} -->
                        <span v-html="medicalReportFile.managementNotes || `-`"></span>
                    </div>
                </div>
                <div class="w-1/2 flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Doctor</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                        {{ $route.params.doctor}}
                      
                    </div>
                </div>
                <div class="w-1/2 flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Date</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                        {{ $route.params.date}}
                      
                    </div>
                </div>
                
                <!-- <div class="w-full flex flex-wrap content-start">
                    <div class="w-full p-1">
                        <h5 class="font-medium text-base">Comment</h5>
                    </div>
                    <div class="w-full text-sm p-1">
                        <span v-html=" medicalReportFile.diagnosisOnAdmission || `-`"></span>
                    </div>
                </div> -->
                <tail-signature></tail-signature>  </div>
        <!-- <div class="w-full flex flex-wrap p-1 my-1 border-t-2 border-gray-800">
            
            <div class="w-full p-1 text-right">
                <h5 class="text-sm font-bold">Printed By: {{ $root.username }}</h5>
            </div>
        </div> -->
    </div>
</template>